import { NavBar, List, Cell, Search, Tag, Empty } from 'react-vant'
import { ArrowLeft, Contact, PhoneO } from '@react-vant/icons'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import request from '../../api/request'

export default function TeacherStudents() {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const classId = searchParams.get('classId')
    const className = searchParams.get('className') || '学生列表'

    const [loading, setLoading] = useState(false)
    const [finished, setFinished] = useState(false)
    const [list, setList] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [page, setPage] = useState(1)

    const onLoad = async () => {
        if (!classId) {
            setFinished(true)
            return
        }
        setLoading(true)
        try {
            const res = await request.get('/academic/students/', {
                params: {
                    class_id: classId,
                    page: page,
                    page_size: 20,
                    search: searchValue
                }
            })
            const newList = res.items || []
            setList(prev => page === 1 ? newList : [...prev, ...newList])

            setPage(prev => prev + 1)
            if (newList.length < 20 || list.length + newList.length >= res.total) {
                setFinished(true)
            }
        } catch (error) {
            console.error('获取学生失败:', error)
            setFinished(true)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setPage(1)
        setList([])
        setFinished(false)
    }, [classId, searchValue])

    return (
        <div className="page-container" style={{ background: '#f8fafc', minHeight: '100vh' }}>
            <NavBar
                title={className}
                leftArrow={<ArrowLeft />}
                onClickLeft={() => navigate(-1)}
                fixed
                placeholder
            />

            <Search
                value={searchValue}
                onChange={setSearchValue}
                placeholder="搜索学生姓名或学号"
                background="#fff"
            />

            <div style={{ marginTop: 12 }}>
                <List
                    loading={loading}
                    finished={finished}
                    onLoad={onLoad}
                    finishedText="没有更多了"
                >
                    {list.length > 0 ? list.map(item => (
                        <Cell
                            key={item.id}
                            title={
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span>{item.real_name}</span>
                                    <Tag type={item.gender === 'male' ? 'primary' : 'warning'} size="small">
                                        {item.gender === 'male' ? '男' : '女'}
                                    </Tag>
                                </div>
                            }
                            label={`学籍号: ${item.student_no || '-'} | 教育ID: ${item.education_id || '-'}`}
                            isLink
                            icon={
                                <div style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: '50%',
                                    background: '#f1f5f9',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: 12
                                }}>
                                    <Contact color="#94a3b8" />
                                </div>
                            }
                            onClick={() => navigate(`/teacher/student-detail/${item.id}`)}
                            value={item.phone && <a href={`tel:${item.phone}`} onClick={(e) => e.stopPropagation()}><PhoneO color="#056b4f" /></a>}
                        />
                    )) : (
                        !loading && <Empty description="暂无学生信息" />
                    )}
                </List>
            </div>
        </div>
    )
}
